import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Configure, useSearchBox } from 'react-instantsearch';
import AlgoliaInsightsMiddleware from '../AlgoliaInsightsMiddleware';
import Products from './Products';

const OrderedCategory = () => {
  const { refine } = useSearchBox();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const searchQueryValue = queryParams.get('query');

  useEffect(() => {
    if (searchQueryValue) {
      refine(searchQueryValue);
    }
  }, [searchQueryValue]);

  return (
    <div className="flex">
      <AlgoliaInsightsMiddleware />
      <Configure ruleContexts={['category-page']} />
      <Products />
    </div>
  );
};

export default OrderedCategory;
